import React, { Component } from 'react'
import Chart from 'react-google-charts'
// const TrendData = [
//     ['', 'Percentage'],
//     ['Jan', 0],
//     ['Feb', 0],
//     ['Mar', 0],
//     ["Apr", 0],
//     ['May', 0],
//     ['Jun', null],
//     ['Jul', null],
//     ['Aug', null],
//     ['Sep', null],
//     ['Nov', null],
//     ['Dec', null],
// ]
const TrendOptions = {
    hAxis: { title: '' },
    vAxis: { title: 'Percentage' },
    legend: 'none',
    trendlines: { 0: {} },
}
class TrendChartSingle extends Component {

    constructor() {
        super();
        this.state = {
            trendValueState: []
        }
    }

    componentDidMount() {
        console.log('trending ', this.props.trendValue)
        this.setState({
            trendValueState: this.props.trendValue
        })
    }

    render() {
        return (
            <div>
                <Chart
                    chartType="ScatterChart"
                    loader={<div>Loading Chart</div>}
                    data={this.state.trendValueState}
                    options={TrendOptions}
                    rootProps={{ 'data-testid': '1' }}
                />
            </div>
        )
    }
}
export default TrendChartSingle